<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='task-card-details-wrapper p'>
  <div class='row'>
    <div class='col-12 mb-sm'>
      <div class='d-flex align-items-center'>
        <div class='circle-icon green'>
          <i class='ui-icon-person'></i>
        </div>
        <div class='align-self-center'>
          <div>
            <span class='color-primary bold'>{{ this.task?.mainDriverName }}</span>
            @if (this.task?.mainDriverPhoneNumber) {
              <span> | </span>
              <span>{{ this.task?.mainDriverPhoneNumber }}</span>
            }
          </div>
          @if (this.task?.secondDriverName) {
            <div class='mt-xs'>
              <span class='color-primary bold'>{{ this.task?.secondDriverName }}</span>
              @if (this.task?.secondDriverPhoneNumber) {
                <span> | </span>
                <span>{{ this.task?.secondDriverPhoneNumber }}</span>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class='col-12 mb-sm'>
      <div class='d-flex  align-items-center'>
        <div class='circle-icon yellow'>
          <i class='ui-icon-local-shipping'></i>
        </div>
        <div class='align-self-center'>
          @if (this.task?.vehicleType) {
            <span>{{ this.task?.vehicleType | translateSelectItem }}</span>
            <span> | </span>
          }
          <span class='color-primary bold'>{{ this.task?.licensePlate }}</span>
        </div>
      </div>
    </div>

    @if (task?.pcsNr && task?.pcsNr > 0) {
      <div class='col-12 mb-sm'>
        <div class='d-flex  align-items-center'>
          <div class='circle-icon red'>
            <i class='well-icon-package bold'></i>
          </div>
          <div class='align-self-center'>
            <span>{{ this.task?.pcsNr }} pcs</span>
            <span> | </span>
            <span>{{ this.task?.sumWeight | number:'1.2-2' }} kg</span>
            <span> | </span>
            <span> {{ this.task?.sumVolume | formatVolume }}m<sup>3</sup></span>
          </div>
        </div>
      </div>
    }
  </div>
</div>


